module.exports = __webpack_public_path__ + "img/flower_leaf_1.4169c80b.png";